<div class="ant-input-number-handler-wrap">
  <span
    unselectable="unselectable"
    class="ant-input-number-handler ant-input-number-handler-up"
    (mousedown)="up($event)"
    (mouseup)="stop()"
    (mouseleave)="stop()"
    [class.ant-input-number-handler-up-disabled]="disabledUp">
    <ui-icon uiType="up" uiClass="ant-input-number-handler-up-inner"></ui-icon>
  </span>
  <span
    unselectable="unselectable"
    class="ant-input-number-handler ant-input-number-handler-down"
    (mousedown)="down($event)"
    (mouseup)="stop()"
    (mouseleave)="stop()"
    [class.ant-input-number-handler-down-disabled]="disabledDown">
    <ui-icon uiType="down" uiClass="ant-input-number-handler-down-inner"></ui-icon>
  </span>
</div>
<div class="ant-input-number-input-wrap">
  <input
    #inputElement
    autocomplete="off"
    class="ant-input-number-input"
    [attr.id]="nzId"
    [attr.autofocus]="nzAutoFocus ? 'autofocus' : null"
    [disabled]="nzDisabled"
    [attr.min]="nzMin"
    [attr.max]="nzMax"
    [placeholder]="nzPlaceHolder"
    [attr.step]="nzStep"
    [attr.inputmode]="nzInputMode"
    (keydown)="onKeyDown($event)"
    (keyup)="stop()"
    [ngModel]="displayValue"
    (ngModelChange)="onModelChange($event)" />
</div>
